// extracted by mini-css-extract-plugin
export var actualite = "detailsActu-module--actualite--763c7";
export var actualiteContentFooter = "detailsActu-module--actualite-content-footer--7250a";
export var actualiteContentFooterAuthor = "detailsActu-module--actualite-content-footer-author--9cc65";
export var actualiteContentFooterBack = "detailsActu-module--actualite-content-footer-back--30e74";
export var actualiteContentFooterDate = "detailsActu-module--actualite-content-footer-date--8cb03";
export var actualiteContentFooterRight = "detailsActu-module--actualite-content-footer-right--94e3f";
export var actualiteImg = "detailsActu-module--actualite-img--e32b9";
export var actualiteTags = "detailsActu-module--actualite-tags--bd2e4";
export var actualiteTaxo = "detailsActu-module--actualite-taxo--d7675";
export var actualiteTitle = "detailsActu-module--actualite-title--c567e";
export var editButton = "detailsActu-module--edit-button--2fd96";
export var pageActu = "detailsActu-module--page-actu--04f19";
export var pageActuAdditionalInfos = "detailsActu-module--page-actu-additional-infos--e531a";
export var socialPanelContainer = "detailsActu-module--social-panel-container--70fef";